import './App.css';
import React from 'react';
import LoginPage from './components/LoginPage.js';
import NewMovementModal from './components/NewMovementModal.js';
import MovementDetailModal from './components/MovementDetailModal.js';
import Settings from './components/Settings.js';
import GlobalSummaryModal from './components/GlobalSummaryModal.js';


class App extends React.Component {
  constructor(props){
    super(props);

    const cfSalvato = localStorage.getItem('codiceFiscaleLoggato');

    this.state = {
      showLogin_page: !cfSalvato,
      paginaAttiva: 'home',
      dataCorrente: new Date(),
      movimentiDelGiorno: [],
      isLoading: false,
      codiceFiscaleLoggato: cfSalvato || null,
      
      // Stati per i filtri
      tipoFiltro: 'giorno', 
      showFiltroMenu: false,
      showGlobalSummaryModal: false,
      showNewMovementModal: false,
      showDetailModal: false,
      metodiPagamentoUtente: [],
      movimentoSelezionatoPerDettaglio: null,
      movimentoDaModificare: null
    };
    this.requestAccess = this.requestAccess.bind(this);
    this.cambiaPagina = this.cambiaPagina.bind(this);
    this.toggleFiltroMenu = this.toggleFiltroMenu.bind(this);
    this.cambiaTipoFiltro = this.cambiaTipoFiltro.bind(this);
    this.giornoPrecedente = this.giornoPrecedente.bind(this);
    this.giornoSuccessivo = this.giornoSuccessivo.bind(this);
    this.cambiaDataManualmente = this.cambiaDataManualmente.bind(this);
    this.caricaMovimenti = this.caricaMovimenti.bind(this);
    this.apriNuovoMovimento = this.apriNuovoMovimento.bind(this);
    this.chiudiAllModals = this.chiudiAllModals.bind(this);
    this.gestisciSuccessoSalvataggio = this.gestisciSuccessoSalvataggio.bind(this);
    this.apriDettaglioMovimento = this.apriDettaglioMovimento.bind(this);
    this.gestisciModificaDaDettaglio = this.gestisciModificaDaDettaglio.bind(this);
    this.eliminaMovimento = this.eliminaMovimento.bind(this);
    this.toggleGlobalSummaryModal = this.toggleGlobalSummaryModal.bind(this);
  }

  componentDidMount() {
    if (this.state.codiceFiscaleLoggato) {
      this.caricaMovimenti();
      this.caricaMetodiPagamento();
    }
  }

  requestAccess(cfInserito){

    if (cfInserito) {
      localStorage.setItem('codiceFiscaleLoggato', cfInserito);
    } else {
      localStorage.removeItem('codiceFiscaleLoggato');
    }

    this.setState({
      showLogin_page: !cfInserito,
      codiceFiscaleLoggato: cfInserito || null,
      paginaAttiva: 'home'
    }, () => {
      if (cfInserito) {
        this.caricaMovimenti();
        this.caricaMetodiPagamento();
      }
    });
  }

  toggleGlobalSummaryModal() {
    this.setState(prevState => ({ showGlobalSummaryModal: !prevState.showGlobalSummaryModal }));
  }


  cambiaPagina(pagina) {
    this.setState({ paginaAttiva: pagina });
  }

  toggleFiltroMenu() {
    this.setState(prevState => ({ showFiltroMenu: !prevState.showFiltroMenu }));
  }

  cambiaTipoFiltro(tipo) {
    this.setState({ 
      tipoFiltro: tipo, 
      showFiltroMenu: false 
    }, () => {
      this.caricaMovimenti();
    });
  }

  async caricaMetodiPagamento() {
    try {
      //const risposta = await fetch(`http://localhost:5001/api/metodi-pagamento?codice_fiscale=${this.state.codiceFiscaleLoggato}`);
      const risposta = await fetch(`/api/metodi-pagamento?codice_fiscale=${this.state.codiceFiscaleLoggato}`);
      const risultato = await risposta.json();
      if (risposta.ok && risultato.success) {
        this.setState({ metodiPagamentoUtente: risultato.metodi });
      }
    } catch (errore) {
      console.error("Errore caricamento metodi di pagamento:", errore);
    }
  }

  apriNuovoMovimento() {
    this.setState({ showNewMovementModal: true, movimentoDaModificare: null });
  }

  apriDettaglioMovimento(movimento) {
    this.setState({ movimentoSelezionatoPerDettaglio: movimento, showDetailModal: true });
  }

  chiudiAllModals() {
    this.setState({ showNewMovementModal: false, showDetailModal: false, movimentoSelezionatoPerDettaglio: null, movimentoDaModificare: null });
  }

  gestisciModificaDaDettaglio(movimento) {
    this.setState({
      showDetailModal: false,          
      movimentoDaModificare: movimento,
      showNewMovementModal: true                  
    });
  }

  async eliminaMovimento(idMovimento) {
    if (!window.confirm("Sei sicuro di voler eliminare questo movimento?")) return;

    try {
      //const risposta = await fetch(`http://localhost:5001/api/elimina-movimento/${idMovimento}`, {
      const risposta = await fetch(`/api/elimina-movimento/${idMovimento}`, {
        method: 'DELETE',
      });
      const risultato = await risposta.json();

      if (risposta.ok && risultato.success) {
        alert("Movimento eliminato con successo!");
        this.chiudiAllModals();
        this.caricaMovimenti();
      } else {
        alert(risultato.message || "Errore durante l'eliminazione.");
      }
    } catch (errore) {
      console.error("Errore di connessione:", errore);
      alert("Impossibile contattare il server.");
    }
  }

  giornoPrecedente(){
    this.setState(prevState => {
      const nuovaData = new Date(prevState.dataCorrente);
      if (this.state.tipoFiltro === 'anno') {
        nuovaData.setFullYear(nuovaData.getFullYear() - 1);
      } else if (this.state.tipoFiltro === 'mese') {
        nuovaData.setMonth(nuovaData.getMonth() - 1);
      } else {
        nuovaData.setDate(nuovaData.getDate() - 1);
      }
      return { dataCorrente: nuovaData };
    }, () => this.caricaMovimenti());
  }

  giornoSuccessivo(){
    this.setState(prevState => {
      const nuovaData = new Date(prevState.dataCorrente);
      if (this.state.tipoFiltro === 'anno') {
        nuovaData.setFullYear(nuovaData.getFullYear() + 1);
      } else if (this.state.tipoFiltro === 'mese') {
        nuovaData.setMonth(nuovaData.getMonth() + 1);
      } else {
        nuovaData.setDate(nuovaData.getDate() + 1);
      }
      return { dataCorrente: nuovaData };
    }, () => this.caricaMovimenti());
  }

  cambiaDataManualmente(e) {
    const valoreSelezionato = e.target.value;
    if (!valoreSelezionato) return;

    let nuovaData = new Date(this.state.dataCorrente);

    if (this.state.tipoFiltro === 'giorno') {
      nuovaData = new Date(valoreSelezionato + 'T00:00:00');
    } else if (this.state.tipoFiltro === 'mese') {
      // L'input type="month" restituisce "YYYY-MM"
      const [anno, mese] = valoreSelezionato.split('-');
      nuovaData.setFullYear(parseInt(anno));
      nuovaData.setMonth(parseInt(mese) - 1);
    } else if (this.state.tipoFiltro === 'anno') {
      // L'input type="number" o l'anno selezionato restituisce "YYYY"
      nuovaData.setFullYear(parseInt(valoreSelezionato));
    }

    this.setState({ dataCorrente: nuovaData }, () => {
      this.caricaMovimenti();
    });
  }

  ottieniMeseStringa() {
    const data = this.state.dataCorrente;
    const anno = data.getFullYear();
    const mese = String(data.getMonth() + 1).padStart(2, '0');
    return `${anno}-${mese}`;
  }

  ottieniAnnoStringa() {
    return String(this.state.dataCorrente.getFullYear());
  }

  gestisciSuccessoSalvataggio() {
    this.chiudiAllModals();
    this.caricaMovimenti();
  }

  async caricaMovimenti() {
    const codice_fiscale = this.state.codiceFiscaleLoggato;
    if (!codice_fiscale) return;

    this.setState({ isLoading: true });

    const data = this.state.dataCorrente;
    const anno = data.getFullYear();
    const mese = String(data.getMonth() + 1).padStart(2, '0');
    const giorno = String(data.getDate()).padStart(2, '0');

    //let endpointQuery = `http://localhost:5001/api/movimenti?codice_fiscale=${codice_fiscale}&tipo_filtro=${this.state.tipoFiltro}&anno=${anno}&mese=${mese}&giorno=${giorno}`;
    let endpointQuery = `/api/movimenti?codice_fiscale=${codice_fiscale}&tipo_filtro=${this.state.tipoFiltro}&anno=${anno}&mese=${mese}&giorno=${giorno}`;

    try {
      const risposta = await fetch(endpointQuery);
      const risultato = await risposta.json();

      if (risposta.ok && risultato.success) {
        this.setState({ movimentiDelGiorno: risultato.movimenti, isLoading: false });
      } else {
        console.error("Errore dal server:", risultato.message);
        this.setState({ movimentiDelGiorno: [], isLoading: false });
      }
    } catch (errore) {
      console.error("Errore di connessione al backend:", errore);
      this.setState({ movimentiDelGiorno: [], isLoading: false });
    }
  }

  ottieniDataStringa() {
    const data = this.state.dataCorrente;
    const anno = data.getFullYear();
    const mese = String(data.getMonth() + 1).padStart(2, '0');
    const giorno = String(data.getDate()).padStart(2, '0');
    return `${anno}-${mese}-${giorno}`;
  }

  formattaData(data) {
    const opzioni = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return data.toLocaleDateString('it-IT', opzioni);
  }

  render(){
    const bilancioTotale = this.state.movimentiDelGiorno.reduce((acc, movimento) => {
      const importoNum = Number(movimento.importo);
      return movimento.eu ? acc + importoNum : acc - importoNum;
    }, 0);

    return (
      <div className="App">
        {this.state.showLogin_page ? (
          <LoginPage onLoginSuccess={(cf) => this.requestAccess(cf)} />
        ) : (
          <div>
            {/* INTESTAZIONE */}
            <div className='Intestazione'>
              <div className='logo_container'>
                <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="logo Sono Povero" className='logo_app' />
                <h1 className="titolo-app">Sono Povero</h1>
              </div>

              <div className='navContainer'>
                <button 
                  onClick={() => this.cambiaPagina('home')}
                  className={`navButton ${this.state.paginaAttiva === 'home' ? 'active' : ''}`}
                >
                  Home
                </button>
                <button 
                  onClick={() => this.cambiaPagina('settings')}
                  className={`navButton ${this.state.paginaAttiva === 'settings' ? 'active' : ''}`}
                >
                  Settings ⚙️
                </button>
              </div>

              <div className='navSpacer'></div>
            </div>
            
            <header className="App-header">
              {this.state.paginaAttiva === 'home' ? (
                <>
                  <div className='newPaymentBox'>
                    <button onClick={this.apriNuovoMovimento} className='newPaymentButton'>Nuovo Movimento</button>
                  </div>

                  {/* BARRA DATA */}
                  <div className='dateBox'>
                    <button onClick={this.giornoPrecedente} className='arrowButton'>◄</button>
                  
                    <div className='spaceData'>
                      {/* FILTRO GIORNALIERO */}
                      {this.state.tipoFiltro === 'giorno' && (
                        <>
                          <input 
                            type="date" 
                            value={this.ottieniDataStringa()}
                            onChange={this.cambiaDataManualmente}
                            className='inputDataNascosto'
                          />
                          <span className='testoDataVisibile'>
                            {this.formattaData(this.state.dataCorrente)}
                          </span>
                        </>
                      )}

                      {/* FILTRO MENSILE */}
                      {this.state.tipoFiltro === 'mese' && (
                        <>
                          <input 
                            type="month" 
                            value={this.ottieniMeseStringa()}
                            onChange={this.cambiaDataManualmente}
                            className='inputDataNascosto'
                          />
                          <span className='testoDataVisibile'>
                            {this.state.dataCorrente.toLocaleString('it-IT', { month: 'long', year: 'numeric' })}
                          </span>
                        </>
                      )}

                      {/* FILTRO ANNUALE */}
                      {this.state.tipoFiltro === 'anno' && (
                        <>
                          <input 
                            type="number" 
                            min="2000" 
                            max="2100"
                            value={this.ottieniAnnoStringa()}
                            onChange={this.cambiaDataManualmente}
                            className='inputDataNascostoAnno'
                          />
                          <span className='testoDataVisibile'>
                            Anno: {this.state.dataCorrente.getFullYear()}
                          </span>
                        </>
                      )}
                    </div>

                    <button onClick={this.giornoSuccessivo} className='arrowButton'>►</button>
                  </div>

                  <div className='mainMovementsContainer'>
                    <h3 className='movementsTitle'>
                      {this.state.tipoFiltro === 'giorno' && 'Movimenti del giorno'}
                      {this.state.tipoFiltro === 'mese' && 'Movimenti del mese'}
                      {this.state.tipoFiltro === 'anno' && 'Movimenti dell\'anno'}
                    </h3>
                    
                    {this.state.isLoading ? (
                      <p className='noMovementsText'>Caricamento in corso...</p>
                    ) : this.state.movimentiDelGiorno.length > 0 ? (
                      <div className='movementsList'>
                        {this.state.movimentiDelGiorno.map((movimento, index) => (
                          <div 
                            key={index}
                            className='movementItem'
                            onClick={() => this.apriDettaglioMovimento(movimento)}
                          >
                            <div style={{ textAlign: 'left' }}>
                              <strong className='movementSubject'>
                                {movimento.soggetto || 'Generale'}
                              </strong>
                              <span className='movementMethod'>
                                {movimento.nome ? `${movimento.nome} ${movimento.conto ? `(${movimento.conto})` : ''}` : 'Conto non specificato'}
                              </span>
                            </div>

                            <div style={{ textAlign: 'right' }}>
                              <span className={movimento.eu ? 'movementTypeEntrata' : 'movementTypeUscita'}>
                                {movimento.eu ? 'Entrata 🟢' : 'Uscita 🔴'}
                              </span>
                              <span className={movimento.eu ? 'amountEntrata' : 'amountUscita'}>
                                {movimento.eu ? '+' : '-'} € {Number(movimento.importo).toFixed(2)}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className='noMovementsText'>Nessun movimento registrato per questo periodo.</p>
                    )}
                  </div>

                  <div 
                    className='dailyTotalBox'
                    onClick={this.toggleGlobalSummaryModal}
                    title="Clicca per il riepilogo globale"
                  >
                    <span className='dailyTotalLabel'>
                      {this.state.tipoFiltro === 'giorno' && 'Bilancio Giornaliero:'}
                      {this.state.tipoFiltro === 'mese' && 'Bilancio Mensile:'}
                      {this.state.tipoFiltro === 'anno' && 'Bilancio Annuale:'}
                    </span>
                    <span className={bilancioTotale >= 0 ? 'dailyTotalPositive' : 'dailyTotalNegative'}>
                      € {bilancioTotale.toFixed(2)}
                    </span>
                  </div>

                  {/* CONTENITORE FILTRO SOTTO IL BILANCIO */}
                  <div className='filterContainerOuter'>
                    <button 
                      onClick={this.toggleFiltroMenu} 
                      className='filterMainButton'
                    >
                      🔍 Filtra per: <span className='filterTypeLabel'>{this.state.tipoFiltro}</span>
                    </button>

                    {this.state.showFiltroMenu && (
                      <div className='filterDropdownMenu'>
                        <button 
                          onClick={() => this.cambiaTipoFiltro('giorno')} 
                          className={`filterDropdownItem ${this.state.tipoFiltro === 'giorno' ? 'active' : ''}`}
                        >
                          📅 Giorno
                        </button>
                        <button 
                          onClick={() => this.cambiaTipoFiltro('mese')} 
                          className={`filterDropdownItem ${this.state.tipoFiltro === 'mese' ? 'active' : ''}`}
                        >
                          📆 Mese
                        </button>
                        <button 
                          onClick={() => this.cambiaTipoFiltro('anno')} 
                          className={`filterDropdownItem ${this.state.tipoFiltro === 'anno' ? 'active' : ''}`}
                        >
                          📊 Anno
                        </button>
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <Settings 
                  metodiPagamento={this.state.metodiPagamentoUtente} 
                  codiceFiscale={this.state.codiceFiscaleLoggato}
                  onAggiornaMetodi={() => this.caricaMetodiPagamento()}
                  onLogout={() => this.requestAccess(null)} 
                />
              )}

              {this.state.showDetailModal && this.state.movimentoSelezionatoPerDettaglio && (
                <MovementDetailModal 
                  movimento={this.state.movimentoSelezionatoPerDettaglio}
                  onClose={this.chiudiAllModals}
                  onEdit={this.gestisciModificaDaDettaglio}
                  onDelete={this.eliminaMovimento}
                />
              )}

              {this.state.showNewMovementModal && (
                <NewMovementModal 
                  codiceFiscale={this.state.codiceFiscaleLoggato}
                  dataCorrenteStringa={this.ottieniDataStringa()}
                  metodiPagamento={this.state.metodiPagamentoUtente}
                  movimentoDaModificare={this.state.movimentoDaModificare}
                  onClose={this.chiudiAllModals}
                  onSuccess={this.gestisciSuccessoSalvataggio}
                />
              )}

              {this.state.showGlobalSummaryModal && (
                <GlobalSummaryModal 
                  movimenti={this.state.movimentiDelGiorno}
                  tipoFiltro={this.state.tipoFiltro}
                  dataCorrente={this.state.dataCorrente}
                  onClose={this.toggleGlobalSummaryModal}
                />
              )}
            </header>
          </div>
        )}
      </div>
    );
  }
}

export default App;
